import React from 'react';
import { getLessonTopicConfig } from '../lessonTopicMap';
import LessonTopicPracticeCard from './LessonTopicPracticeCard';

const QuantLessonPracticeSlot = ({ lessonId }) => {
  const topicConfig = getLessonTopicConfig(lessonId);

  if (!topicConfig) {
    return null;
  }

  return (
    <LessonTopicPracticeCard
      lessonId={lessonId}
      topicIds={topicConfig.topicIds}
      topicLabel={topicConfig.label}
      subconcepts={topicConfig.practiceSubconcepts ?? topicConfig.subconcepts}
    />
  );
};

export default QuantLessonPracticeSlot;
